import React from 'react';

export default (day) => (
  <span>
    {day.getDate()}
  </span>
);
